"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _Zoom = _interopRequireDefault(require("@material-ui/core/Zoom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * ** Tooltips display informative text when users hover over, focus on, or tap an element. **
 *
 */
var Tooltip = function Tooltip(_ref) {
  var title = _ref.title,
      isOpen = _ref.isOpen,
      children = _ref.children;

  var MyComponent = /*#__PURE__*/_react.default.forwardRef(function MyComponent(props, ref) {
    return /*#__PURE__*/_react.default.createElement("span", _extends({}, props, {
      ref: ref
    }), children);
  });

  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    TransitionComponent: _Zoom.default,
    interactive: true,
    title: title,
    open: isOpen,
    placement: "top"
  }, /*#__PURE__*/_react.default.createElement(MyComponent, null));
};

Tooltip.propTypes = {
  /** The tooltip text to display */
  title: _propTypes.default.string.isRequired,

  /**  Open tooltip on demand stops hover interaction */
  isOpen: _propTypes.default.bool,

  /** The element to be placed the tooltip on top */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
Tooltip.defaultProps = {
  isOpen: undefined,
  children: null
};
var _default = Tooltip;
exports.default = _default;